document.addEventListener('DOMContentLoaded', () => {
  const panel = document.getElementById('agcFloatingPanel');
  if (!panel) return;

  const closeBtn = panel.querySelector('.agc-floating-close');
  let wiggleInterval;

  // Show once per session
  if (sessionStorage.getItem('agcFloatingSeen')) return;
  sessionStorage.setItem('agcFloatingSeen', 'true');

  // Trigger slide-in
  panel.classList.add('visible');

  // Initial wiggle after slide-in
  setTimeout(() => {
    panel.classList.add('wiggle');
    setTimeout(() => panel.classList.remove('wiggle'), 700);
  }, 900);

  // Repeat wiggle (POLITE timing)
  wiggleInterval = setInterval(() => {
    if (!panel.classList.contains('visible')) return;

    panel.classList.add('wiggle');
    setTimeout(() => panel.classList.remove('wiggle'), 700);
  }, 15000); // 👈 15 seconds (recommended)

  // Close behavior
  closeBtn?.addEventListener('click', () => {
    panel.classList.remove('visible');
    panel.style.display = 'none';
    clearInterval(wiggleInterval);
  });
});
